import { useEffect } from 'react';

import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { type AxiosError, type AxiosResponse } from 'axios';

import { type HttpClientError } from '~/utils/APIError';
import { newRelic } from '~/utils/newRelic/newRelic';

import { INVOICE_ITEMS_CACHE_KEY } from '../constants/invoicePage.const';
import * as invoicesService from '../services/invoices.service';
import { type InvoiceItemsResponse } from '../types/invoice.type';

export const useFetchInvoiceItems = (
  invoiceId: string,
): UseQueryResult<AxiosResponse<InvoiceItemsResponse, AxiosError>, HttpClientError> => {
  const query = useQuery<AxiosResponse<InvoiceItemsResponse, AxiosError>, HttpClientError>({
    queryFn: () => invoicesService.getInvoiceItemsOfInvoice(invoiceId),
    queryKey: [invoiceId, INVOICE_ITEMS_CACHE_KEY],
  });

  useEffect(() => {
    if (query.error)
      newRelic.noticeError('Error while fetching invoice items', { error: query.error });
  }, [query.error]);

  return query;
};
